import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  Root,
  Hero,
  HeroImageContainer,
  HeroContent,
  HeroClubLogoContainer,
  StrategiesLogo,
  DescSection,
  DescTitle,
  Paragraph,
  Section,
  SectionTitle,
  SectionContainer,
  Grid,
} from './FreeOnlineLessons.style';

import ClubHLogo from '../../../assets/clubh-logo.svg?react';
import logoStrategiesSrc from '../../../assets/logo-strategies@2x.png';

import { LessonVideoCard } from '../../../components/LessonVideoCard/LessonVideoCard';

import { getFinancials, getLeadership, getRevenueAndRetention } from './config';

export const FreeOnlineLessons = () => {
  const intl = useIntl();
  const financials = getFinancials(intl);
  const leadership = getLeadership(intl);
  const revenueAndRetention = getRevenueAndRetention(intl);

  return (
    <Root>
      <Hero>
        <HeroImageContainer />
        <HeroContent>
          <HeroClubLogoContainer>
            <ClubHLogo />
          </HeroClubLogoContainer>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31px"
            height="31px"
            viewBox="0 0 31 31"
            style={{ flexShrink: 0 }}
          >
            <path
              fill="#fff"
              d="m29.64 0 1.337 1.334-14.142 14.165L31 29.64l-1.334 1.336-14.165-14.141L1.36 31 .024 29.666l14.141-14.165L0 1.36 1.333.024l14.166 14.141L29.64 0Z"
            />
          </svg>
          <StrategiesLogo
            src={logoStrategiesSrc}
            alt={intl.formatMessage({ defaultMessage: 'Strategies Logo' })}
          />
        </HeroContent>
      </Hero>

      <DescSection>
        <DescTitle>
          <FormattedMessage defaultMessage="Free online lessons" />
        </DescTitle>
        <p>
          <Paragraph>
            <FormattedMessage defaultMessage="Build the business and career you want with expert-led courses and tools. This platform gives you the tools to grow a profitable business and a fulfilling career. Whether you lead a team or work solo, you'll learn how to grow, lead, and scale- on your terms, at your own pace with support every step of the way." />
          </Paragraph>
        </p>
      </DescSection>

      <Section className="--bg">
        <SectionContainer>
          <SectionTitle>
            <FormattedMessage defaultMessage="FINANCIALS" />
          </SectionTitle>
          <Grid>
            {financials.map((video) => (
              <LessonVideoCard
                key={video.vimeoId || video.download}
                title={video.title}
                desc={video.desc}
                info={video.info}
                vimeoId={video.vimeoId}
                thumbnail={video.thumbnail}
                download={video.download}
              />
            ))}
          </Grid>
        </SectionContainer>
      </Section>

      <Section>
        <SectionContainer>
          <SectionTitle>
            <FormattedMessage defaultMessage="LEADERSHIP" />
          </SectionTitle>
          <Grid>
            {leadership.map((video) => (
              <LessonVideoCard
                key={video.vimeoId || video.download}
                title={video.title}
                desc={video.desc}
                info={video.info}
                vimeoId={video.vimeoId}
                thumbnail={video.thumbnail}
                download={video.download}
              />
            ))}
          </Grid>
        </SectionContainer>
      </Section>

      <Section className="--bg">
        <SectionContainer>
          <SectionTitle>
            <FormattedMessage defaultMessage="REVENUE & RETENTION" />
          </SectionTitle>
          <Grid>
            {revenueAndRetention.map((video) => (
              <LessonVideoCard
                key={video.vimeoId || video.download}
                title={video.title}
                desc={video.desc}
                info={video.info}
                vimeoId={video.vimeoId}
                thumbnail={video.thumbnail}
                download={video.download}
              />
            ))}
          </Grid>
        </SectionContainer>
      </Section>
    </Root>
  );
};
